/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';
import { SolutionSegmentSelectedRsDtoModel } from '../solution-segment-selected-rs-dto.model';

export class MasterRoutingSolutionDtoModel extends JSONable {
  uuid: string | undefined = undefined;

  shipmentGroupSolutionUuid: string | undefined = undefined;

  solutionSegmentSelectedRsDtoSet: SolutionSegmentSelectedRsDtoModel[] | undefined = undefined;

  selectedCurrency: string | undefined = undefined;

  preferred: boolean | undefined = undefined;

  createdAt: string | undefined = undefined;
}
